/**
 * @param object
 * @param property
 * @param defaultValue
 * @returns {*}
 */
export function setOrFallbackValue(object, property, defaultValue) {
    if (typeof object !== 'undefined' && typeof object[property] !== 'undefined') {
        return object[property];
    }

    return defaultValue;
}
